import ScopeEmissionForm from "./ScopeEmissionForm";

const Scope2Form = () => (
  <ScopeEmissionForm scopeKey="scope2" label="Scope 2 Emissions" />
);

export default Scope2Form;
